import Vue from 'vue';
import Router, { RouteConfig, Route, RawLocation } from 'vue-router';

import World from './world/World.vue';
import CountriesList from '@/world/CountriesList.vue';
import AbroadInfo from '@/world/AbroadInfo.vue';

import Russia from '@/russia/Russia.vue';

import Axios from 'axios';
import Import from './import/Import.vue';
import store from '@/plugins/store';
import Settings from '@/settings/Settings.vue';
import Login from './login/Login.vue';

import OidcCallback from '@/components/oidc/OidcCallback.vue';
import OidcPopupCallback from '@/components/oidc/OidcPopupCallback.vue';
import OidcCallbackError from '@/components/oidc/OidcCallbackError.vue';
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';
import RussiaResort from './russiaResort/RussiaResort.vue';
import RussiaResortRegionTable from './russiaResort/RussiaResortRegionTable.vue';
import RussiaResortRegionMap from './russiaResort/RussiaResortRegionMap.vue';

Vue.use(Router);

const routes: RouteConfig[] = [
	{ path: '/', redirect: '/russia' },
	{
		path: '/world',
		components: {
			default: World,
			leftPanel: CountriesList,
			rightPanel: AbroadInfo,
		},
		meta: { requireManager: true },
	},
	{
		path: '/russia',
		components: {
			default: Russia,
		},
	},
	{
		path: '/russiaresort',
		name: 'resort',
		components: {
			default: RussiaResort,
			leftPanel: RussiaResortRegionTable,
		},
		meta: { requireTest: true },
		children: [
			{
				path: 'region/:code',
				props: (route) => ({ regionCode: +route.params.code }),
				name: 'resortRegionPreview',
			},
			{
				path: 'map/:code',
				props: (route) => ({ regionCode: +route.params.code }),
				name: 'resortRegionMap',
				component: RussiaResortRegionMap,
			},
		],
	},
	{
		path: '/settings',
		component: Settings,
		meta: { requireAdmin: true },
	},
	{ path: '/login', component: Login },
	{
		path: '/import',
		component: Import,
		meta: { requireManager: true },
	},
	{
		path: '/oidc-callback', // Needs to match redirectUri in you oidcSettings
		name: 'oidcCallback',
		component: OidcCallback,
	},
	{
		path: '/oidc-popup-callback', // Needs to match popupRedirectUri in you oidcSettings
		name: 'oidcPopupCallback',
		component: OidcPopupCallback,
	},
	{
		path: '/oidc-callback-error', // Needs to match redirect_uri in you oidcSettings
		name: 'oidcCallbackError',
		component: OidcCallbackError,
		meta: {
			isPublic: true,
		},
	},
	{ path: '*', redirect: '/' },
];

const router = new Router({
	mode: 'history',
	linkActiveClass: 'active',
	routes,
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidc'));

// action restricter
router.beforeEach((to, from, next) => {
	if (store.getters['user/getIsAdmin']) {
		next();
	} else {
		if (to.matched.some((r) => r.meta.requireManager)) {
			if (store.getters['user/getIsManager']) {
				next();
			} else {
				next(false);
			}
		} else if (to.matched.some((r) => r.meta.requireAdmin)) {
			if (store.getters['user/getIsAdmin']) {
				next();
			} else {
				next(false);
			}
		} else if (to.matched.some((r) => r.meta.requireTest)) {
			if (store.getters['user/getIsTester']) {
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	}
});

Vue.use(Router);

export default router;
